/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../common/auto-form';
import { APV_SELECT_ONE_FIELDS } from './fields';
import { APVSelectOneResultView } from './result-view';
import {
  APVSelectOneFormValues,
  apvSelectOneDefaults,
  apvSelectOneSchema,
} from './schema';
import { PRODUCT, simulateAPVSelectOne } from './service';

export function APVSelectOnePage() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);

  const mutation = useMutation({
    mutationFn: (values: APVSelectOneFormValues) => simulateAPVSelectOne({ values }),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={APV_SELECT_ONE_FIELDS}
            schema={apvSelectOneSchema}
            defaults={apvSelectOneDefaults}
            isLoading={mutation.isLoading}
            expectedProduct={PRODUCT}
            onSubmit={(values) => {
              const payload = {
                product: PRODUCT, ...values, debug: true,
              };
              setLastRequest(payload);
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <APVSelectOneResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
